module.exports = __webpack_public_path__ + "static/media/ic_checkbox_check.bb99d253.svg";